import React from 'react';
import '../../components/cards/poll/pollCardV1/css/style.scss';
import { Skeleton } from '../Skeleton';

const PollLoader = () => {
  return (
    <>
      <div className="w-100 pollCardV1Box shadow rounded-3 bg-white position-relative overflow-hidden p-3 p-md-4">
        <div className="w-100 pollCrdV1Btm">
          <div className="crdV1topPart d-flex align-items-center justify-content-between">
            <div className="quizCardV1TopRight d-inline-flex align-items-center">
              <h4 className="text-black text-uppercase fs-4">
                <Skeleton variant="rectangular" width={60} height={22} />
              </h4>
            </div>
          </div>
          <div className="w-100 d-flex text-start cardV1Topic my-2">
            <div className="cardV1TopicContent">
              <h4 className="text-black fs-16 fw-medium">
                <Skeleton variant="text" width={200} height={25} />
                <Skeleton variant="text" width={200} height={25} />
                <Skeleton variant="text" width={80} height={25} />
              </h4>
            </div>
          </div>
          <div className="w-100 cardV1Ftr">
            <Skeleton variant="rectangular" width={'100%'} height={35} className="mb-4 rounded" />
            <Skeleton variant="rectangular" width={'100%'} height={35} className="mb-4 rounded" />
            <Skeleton variant="rectangular" width={'100%'} height={35} className="mb-4 rounded" />
            {/* <Skeleton variant="rectangular" width={'100%'} height={30} className="mb-4 rounded" /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PollLoader;
